routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.compare', {
      url: "/comparar-productos/{categoryId}/{products:string}",
      params: {
        products: {
          array: true
        }
      },
      template: `<compare-products sh-ctrl="shCtrl"></compare-products>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/compare-products/compare-products.config.js
 **/